import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledAppContainer = styled.div`
    width: 100%;
    flex: 1;
    padding: 0 16px;

    ${media.md`
         max-width: 1440px;
         padding: 0 48px;
         margin: 0 auto;
    `}
`;